module.exports = __webpack_public_path__ + "static/media/expander.551a9c21.svg";